import graphql from './graphql';

const query = /* GraphQL */ `
  query Course_listCoursesByDepartment($departmentId: String) {
    Course_listCoursesByDepartment(departmentId: $departmentId) {
      EnterpriseCourses {
        id
        name
        Enterprise {
          Terminals {
            name
          }
        }
        duration
        CourseCategory {
          name
        }
        CourseType {
          type
        }
      }
      DepartmentCourses {
        id
        name
        isChecked
        Enterprise {
          Terminals {
            name
          }
        }
        duration
        CourseCategory {
          name
        }
        CourseType {
          type
        }
      }
    }
  }
`;

const CourseListCoursesByDepartment = async departmentId =>
  graphql(query, { departmentId }).then(data => data.Course_listCoursesByDepartment);

export default CourseListCoursesByDepartment;
